import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Badge from '../Badge';
import Icon from '../Icon';

function DefaultToken(_ref) {
  var keyboardControls = _ref.keyboardControls,
      removeToken = _ref.removeToken,
      selectFirstToken = _ref.selectFirstToken,
      selectLastToken = _ref.selectLastToken,
      selectPreviousToken = _ref.selectPreviousToken,
      selectNextToken = _ref.selectNextToken,
      token = _ref.token,
      tokenIndex = _ref.tokenIndex,
      restProps = _objectWithoutPropertiesLoose(_ref, ["keyboardControls", "removeToken", "selectFirstToken", "selectLastToken", "selectPreviousToken", "selectNextToken", "token", "tokenIndex"]);

  return /*#__PURE__*/React.createElement(Badge, _extends({
    size: "sm",
    renderRight: /*#__PURE__*/React.createElement(Icon, {
      name: "close",
      size: "xs",
      cursor: "pointer",
      onClick: function onClick() {
        return removeToken(false);
      }
    })
  }, keyboardControls, restProps), token);
}

export default DefaultToken;